import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'have_any_cases_of_threats_such_as_reporting_to_authorities_depo'

export const dataPointDefinition = {
  retracedId: 'have_any_cases_of_threats_such_as_reporting_to_authorities_depo',
  name: "Have any cases of threats, such as reporting to authorities, deportation or threats against a worker's family/close associates, or cancelation of visa or other documents (e.g. work permits, residence permits, etc.) occurred in order to force migrant workers to stay at the job?",
  description:
    "Workers can be made very vulnerable when their work visa is linked to a particular employer. Answer Yes if the employer threatened any workers with deportation or other penalties associated with their migrant status to make them work beyond their contract or to force them to stay on the job. \r\r\n\r\r\nMigrant workers in irregular situations are not necessarily forced laborers, but they could be if the employer exploits the worker's irregular status to withhold wages or require work beyond the scope of the contract (such as sexual favors or overtime beyond legal limits). Employers can manipulate workers' fear not only of deportation, but also of torture and mistreatment by the authorities, especially if workers have had bad experiences with law enforcement in their home countries.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hb-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9980,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
